module.exports = __webpack_public_path__ + "static/fonts/NotoSansKR-Medium.2de688e.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/views/nca/css/font/NotoSansKR-Medium.woff2
// module id = MUwJ
// module chunks = 0